import { useLazyQuery } from "@apollo/client/react"; import { useState, useEffect, Fragment } from 'react';

import RestoreIcon from '@mui/icons-material/Restore';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { CustomChip } from "../../../../../components/chip/Chip";
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { adaptHistorialArray, GET_HISTORIAL_CAPA } from '../../../../../data/graphQL/queries/Capas/getHistorialCapa';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const HistorialModal = ({
  idGestionCapa,
  estados,
  isPopoverMenuOption = false
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [historial, setHistorial] = useState([]);

  const [estadosColor] = useState({
    1: { isYellow: true },
    2: { isGreen: true },
    3: { isRed: true },
    4: { isRed: true },
    5: { isGreen: true }
  });

  const getEstado = (idEstado) => {
    const color = estadosColor[idEstado];
    const estadoName = !estados ? '' : estados?.find((x) => x.id === idEstado)?.displayName;
    return (
      <CustomChip
        label={estadoName}
        {...color}
        sx={{ marginLeft: '10px', height: '26px' }} />);


  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => { setOpenModal(false); };

  const [getHistorial, { data: dataHistorial, loading: loadingHistorial }] = useLazyQuery(GET_HISTORIAL_CAPA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataHistorial || loadingHistorial) return;
    if (!dataHistorial?.historialCapaByIdGestionCapa) return toast.error('No se pudo cargar la información del historial, intentelo nuevamente más tarde.');
    setHistorial(adaptHistorialArray(dataHistorial?.historialCapaByIdGestionCapa));
  }, [dataHistorial]);

  useEffect(() => {
    if (!idGestionCapa) return;
    getHistorial({ variables: { idGestionCapa } });
  }, [idGestionCapa]);

  return (
    <>
      {!isPopoverMenuOption && <CustomButton
        label='Historial'
        className='adjuntos'
        disabled={false}
        onClick={handleOpenModal}
        endIcon={<RestoreIcon />}
        variant='standar' />
      }
      {isPopoverMenuOption &&
        <div
          aria-hidden='true'
          onClick={handleOpenModal}
          className='item-option clickable-option'
        >
          <RestoreIcon className='edit-icon' />
          <span className='toggle-action'>Historial</span>
        </div>
      }
      <CustomDialog
        open={openModal}
        title={'Historial'}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth
        id='capa-historial-modal'>

        <Timeline
          className="lineTime">

          {historial?.map((etapa, index) => {
            const isLast = index === historial.length - 1;
            return <Fragment key={`id-historial${etapa.id}-index-${index}`}>
              <TimelineItem>
                <TimelineOppositeContent className="leftContent">
                  <span className="date">
                    <CalendarTodayIcon className="iconCalendar" />
                    <div className='fecha-realizacion'>{!!etapa.fecha ? moment(etapa.fecha).format("DD/MM/YYYY HH:mm") : '-'}</div>
                  </span>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot sx={{
                    width: '4px',
                    height: '4px',
                    bgcolor: '#0063BE',
                    border: '3px solid #B9D1EB',
                    borderRadius: '50%'
                  }} />
                  {!isLast && <TimelineConnector sx={{ bgcolor: '#B9D1EB', border: '3px' }} />}
                </TimelineSeparator>
                <TimelineContent className="rightContent">
                  <Accordion className='card-contenido-detalle' defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header">

                      <div className="titulo-etapa-historial"><strong>{etapa?.etapa} </strong></div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="estadoHistorial"><strong>Usuario: </strong><label className='motivo-rechazo-descripcion'>{etapa.usuario}</label></div>
                      <div className="estadoHistorial"><strong>Estado: </strong>{getEstado(etapa.idEstado)}</div>
                      {!!etapa.descripcion && <div className="estadoHistorial"><strong>Motivo: </strong><label className='motivo-rechazo-descripcion'>{etapa.descripcion}</label></div>}
                    </AccordionDetails>
                  </Accordion>
                </TimelineContent>
              </TimelineItem>
            </Fragment>;
          })
          }
        </Timeline>
      </CustomDialog>
    </>);

};

export default HistorialModal;